import { Store } from 'interfaces';
import { v4 as uuid } from 'uuid';

export default function resetAppState(state: Store.State) {
  state.availability = undefined;
  state.transactionID = uuid();
}
